import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { MailCheck, XCircle, Loader2 } from "lucide-react";
import Btn from "../components/Btn";
import ThemeToggle from "../components/ThemeToggle";
import api, { apiErr } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { refresh } = useAuth();
  const [state, setState] = useState("loading"); // loading | ok | error
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (!token) {
      setState("error");
      setMsg("Tautan verifikasi tidak lengkap.");
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/verify-email", { token });
        setState("ok");
        setMsg(data.message || "Email berhasil diverifikasi!");
        refresh?.();
      } catch (err) {
        setState("error");
        setMsg(apiErr(err));
      }
    })();
  }, [token, refresh]);

  return (
    <div className="min-h-screen bg-su-bg flex flex-col">
      <div className="p-4 flex items-center justify-end"><ThemeToggle /></div>
      <div className="flex-1 grid place-items-center px-4 pb-10">
        <div className="w-full max-w-md">
          <div className="card-chunky p-8 text-center animate-pop" data-testid="verify-card">
            {state === "loading" && (
              <>
                <Loader2 className="w-12 h-12 text-su-primary animate-spin mx-auto mb-4" />
                <h1 className="font-heading font-black text-xl text-su-text">Memverifikasi email...</h1>
              </>
            )}
            {state === "ok" && (
              <>
                <div className="w-14 h-14 rounded-2xl bg-su-success/20 grid place-items-center mx-auto mb-4">
                  <MailCheck className="w-7 h-7 text-su-success" />
                </div>
                <h1 className="font-heading font-black text-2xl text-su-text mb-2">Email Terverifikasi! 🎉</h1>
                <p className="text-su-muted font-medium text-sm mb-6" data-testid="verify-message">{msg}</p>
                <Link to="/dashboard"><Btn className="w-full" data-testid="verify-continue">Lanjut ke Dashboard</Btn></Link>
              </>
            )}
            {state === "error" && (
              <>
                <div className="w-14 h-14 rounded-2xl bg-su-danger/20 grid place-items-center mx-auto mb-4">
                  <XCircle className="w-7 h-7 text-su-danger" />
                </div>
                <h1 className="font-heading font-black text-2xl text-su-text mb-2">Verifikasi Gagal</h1>
                <p className="text-su-muted font-medium text-sm mb-6" data-testid="verify-message">{msg}</p>
                <Link to="/dashboard"><Btn variant="secondary" className="w-full" data-testid="verify-back">Kembali ke Dashboard</Btn></Link>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
